import React, {forwardRef} from 'react';
import './toggleSwitch.scss';

interface ToggleSwitchProps {
    id: string;
    isOn: boolean;
    color?: 'primary' | 'secondary' | 'info' | 'warning' | 'error';
    handleToggle: () => void;
    disabled?: boolean;
}

const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
    ({id, isOn, color = 'secondary', handleToggle, disabled = false}, ref) => {
        return (
            <div className={`c-toggleSwitch c-toggleSwitch--${color}`} data-cy="privacyToggle">
                <input
                    ref={ref}
                    className="c-toggleSwitch__input"
                    id={id}
                    type="checkbox"
                    checked={isOn}
                    onChange={handleToggle}
                    disabled={disabled}
                />
                <div className="c-toggleSwitch__body">
                    <label className="c-toggleSwitch__label" htmlFor={id}>
                        <span className="c-toggleSwitch__label_button" />
                    </label>
                </div>
            </div>
        );
    }
);

export default ToggleSwitch;
